import React from 'react';

import ModelYearRangeFilter from './ModelYearRangeFilter';
import PriceRangeFilter from './PriceRangeFilter';
import MileageRangeFilter from './MileageRangeFilter';
import EngineFilter from './EngineFilter';
import TransmissionFilter from './TransmissionFilter';
import DriveTrainFilter from './DriveTrainFilter';
import MakeModelFilter from './MakeModelFilter';
import ConditionFilter from './ConditionFilter';
import LocationFilter from './LocationFilter';
import FeaturesTechnologyFilter from './FeaturesTechnologyFilter';
import BodyStylesFilter from './BodyStylesFilter';
import AdvancedFilter from './AdvancedFilter';
import TruckOptionsFilter from './TruckOptionsFilter';
import ColorsFilter from './ColorsFilter';
import CategoryFilter from './CategoryFilter';

import styles from './styles';
import SaveClearSearchButtons from './SaveClearSearchButtons';

export default function SearchFilter({
  hideOnMobile = false,
}: {
  hideOnMobile?: boolean;
}): JSX.Element {
  return (
    <div className="search-filters-container">
      <div className={`${hideOnMobile ? 'hide-on-mobile' : ''}`}>
        <SaveClearSearchButtons />
      </div>
      <div className="mobile-filter">
        <LocationFilter expanded />
      </div>
      <MakeModelFilter expanded />
      <ModelYearRangeFilter expanded />
      <PriceRangeFilter expanded />
      <MileageRangeFilter expanded />
      <BodyStylesFilter />
      <EngineFilter />
      <TransmissionFilter />
      <DriveTrainFilter />
      <FeaturesTechnologyFilter />
      <ConditionFilter />
      <ColorsFilter />
      <CategoryFilter />
      <TruckOptionsFilter />
      <AdvancedFilter />
      <style jsx>{styles}</style>
    </div>
  );
}
